// Which routes stay reachable while onboarding is unfinished.
//
// Router-free on purpose. The gate that uses this imports react-router-dom,
// which is ESM-only and cannot be resolved by this project's Jest — so a rule
// living in that file is a rule no test can read. Keeping it here means the
// list of ways out of onboarding is the one part that is actually verified.

/**
 * Signing in and out, the legal pages, and the flow itself.
 *
 * Someone part-way through onboarding must still be able to read the terms
 * they are being asked to accept, and must still be able to leave. Everything
 * else waits until they have a photo and a video.
 */
export const ALWAYS_REACHABLE = [
  '/onboarding',
  '/login',
  '/registration',
  '/reset-password',
  '/privacy-policy',
  '/terms-of-service',
  '/support',
  '/',
];

export const isExemptFromOnboarding = (pathname: string): boolean =>
  ALWAYS_REACHABLE.includes(pathname);
